<div class="layout-container">
  <div class="title-container">
    <h3 class="title">
      {{ 'ACTIVATION.SELECTION_PAGE.ACTIVATION_CART.SELECTED_PRODUCTS' | translate }}
    </h3>
  </div>

  <mat-list class="list-container">
    <mat-list-item *ngIf="!appCartItems && appCartItems?.length === 0" class="body-container">
      <div class="empty-circle"></div>
      <span class="empty-title">
        {{ 'ACTIVATION.SELECTION_PAGE.ACTIVATION_CART.NO_PRODUCTS_OR_PACKAGES_SELECTED' | translate }}
      </span>
    </mat-list-item>

    <ng-container *ngFor="let item of appCartItems">
      <mat-list-item
        *ngIf="item?.quantity > 0"
        style="height: auto"
        [ngClass]="{
          blink: newItemIds.indexOf(item?.activatableItem?.appId) >= 0
        }"
        class="body-container blink"
      >
        <div class="item-container">
          <div class="item-sub-container">
            <div class="item-title">
              <div class="item-icon">
                <va-icon
                  [diameter]="32"
                  [iconName]="item.activatableItem?.name"
                  [iconUrl]="item.activatableItem?.icon"
                ></va-icon>
              </div>
              <span class="item-name-container">
                <h4 class="item-name">
                  {{
                    item?.activatableItem?.name +
                      (showBadge(item.isTrial, item.editionId) && item.editionName ? ' | ' + item.editionName : '')
                  }}
                  <span *ngIf="item?.quantity > 1">({{ item.quantity }})</span>
                </h4>
              </span>
            </div>
            <div
              *ngIf="
                item?.status === activatedStatus && !item.activatableItem.allowMultipleActivations && !item.isTrial
              "
              class="item-active"
            >
              {{ 'ACTIVATION.SELECTION_PAGE.ACTIVATION_CART.CURRENTLY_ACTIVE' | translate }}
            </div>
            <div
              *ngIf="
                item?.status === cancelledStatus && !item.activatableItem.allowMultipleActivations && !item.isTrial
              "
              class="item-active"
            >
              {{ 'ACTIVATION.SELECTION_PAGE.CANCELED' | translate }}
            </div>
            <div class="button-container">
              <button mat-icon-button (click)="removeAppSelected(item)">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </mat-list-item>
    </ng-container>
  </mat-list>
</div>
